export default __webpack_public_path__ + "static/media/221091_info2.a859fca7.pdf";